import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllContratos } from "../../../redux/actions/contrato";
import CircularLoading from "../../commons/loading/CircularLoading";
import { StyledContratoCardContainer } from "../../styled/Empresa";
import ContratoCard from "./ContratoCard";
import ModalSendEmail from "./ModalSendEmail";

const ContratoContainer = () => {
  const dispatch = useDispatch();

  const contratos = useSelector((state) => state.contrato.contratos);
  const contratoPDF = useSelector((state) => state.contrato.contratoPDF);

  const [open, setOpen] = useState(false);
  const [codigoContrato, setCodigoContrato] = useState("");

  useEffect(() => {
    if (!contratos.data.length) dispatch(getAllContratos());
  }, []);

  const handleOpenModal = (codigo) => {
    setCodigoContrato(codigo);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <StyledContratoCardContainer.Container>
      {!contratos.loading && !contratoPDF.loading ? (
        contratos.data.map((contrato) => (
          <ContratoCard
            key={contrato.codigoUnificado}
            nombreContrato={contrato.nombre}
            openModal={handleOpenModal}
            codigoContrato={contrato.codigoUnificado}
          />
        ))
      ) : (
        <CircularLoading />
      )}
      <ModalSendEmail
        open={open}
        handleClose={handleCloseModal}
        codigoContrato={codigoContrato}
      />
    </StyledContratoCardContainer.Container>
  );
};

export default ContratoContainer;
